import { DocShape } from ".";
import { BorrowerEntity } from "./borrowers";
import { TaxIncomeSubsection } from "./income";

export enum ReoOwnershipStatuses {
  IsBeingSold = "IsBeingSold",
  RentedOut = "RentedOut",
  Sold = "Sold",
  VacantLand = "VacantLand",
  VacationSecondHome = "VacationSecondHome",
  PrincipalResidence = "PrincipalResidence",
  SubjectProperty = "SubjectProperty",
  OtherInvestment = "OtherInvestment",
}

export const ReoOwnershipStatusDisplayValues: { [key in ReoOwnershipStatuses]: string } = {
  [ReoOwnershipStatuses.IsBeingSold]: "Is being sold",
  [ReoOwnershipStatuses.RentedOut]: "Rented out",
  [ReoOwnershipStatuses.Sold]: "Sold",
  [ReoOwnershipStatuses.VacantLand]: "Vacant land",
  [ReoOwnershipStatuses.VacationSecondHome]: "Vacation/second home",
  [ReoOwnershipStatuses.PrincipalResidence]: "Principal residence",
  [ReoOwnershipStatuses.SubjectProperty]: "Subject property",
  [ReoOwnershipStatuses.OtherInvestment]: "Other investment",
};

export interface OwnedRealEstate {
  id: number;
  loan_application_id: number;
  borrower_entity: BorrowerEntity;
  address_line1: string;
  address_line2: string;
  city: string;
  documents: DocShape[];
  state: string;
  postal_code: string;
  monthly_rental_income: string;
  operator_address_line1?: string;
  operator_address_line2?: string;
  operator_city?: string;
  operator_state?: string;
  operator_postal_code?: string;
  ownership_status: ReoOwnershipStatuses;
  cash_close_net_equity: number | null;
  is_trade_in: boolean | null;
  operator_ownership_status?: ReoOwnershipStatuses;
  proceeds_text: string;
  sale_status?: string;
  tax_income_subsections: TaxIncomeSubsection[];
  schedule_e_property_labels: any[];
  usable_net_sale_proceeds: string | null;
  use_proceeds_as_asset: boolean | null;
  total_monthly_pitia: number;
  estimated_monthly_p_and_i: number;
  estimated_monthly_hoa_or_condo_dues: number;
  estimated_monthly_hazard_insurance: number;
  operator_monthly_other: number | null;
  operator_monthly_hoa_or_condo_dues: number | null;
  operator_monthly_hazard_insurance: number | null;
  operator_monthly_p_and_i: number | null;
  operator_annual_hazard_insurance: number | null;
  operator_annual_property_taxes: number | null;
}
